import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/gold-logo-transparent.png'


const _hoisted_1 = { class: "flex flex-col p-5" }
const _hoisted_2 = { class: "h-screen" }
const _hoisted_3 = { class: "flex-1 flex items-center justify-center mb-5" }
const _hoisted_4 = { class: "block max-w-xs p-6 bg-white border border-gray-200 rounded-lg shadow hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700" }
const _hoisted_5 = { class: "mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white" }
const _hoisted_6 = { class: "w-full flex flex-row flex-wrap gap-5" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "p-2" }
const _hoisted_10 = { class: "font-semibold text-lg" }
const _hoisted_11 = { class: "font-normal mb-2" }
const _hoisted_12 = { class: "text-gray-400" }

import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import EventService from '@/service/event.service';
import EventModal from '@/components/admin-dashboard/EventModal.vue';
import LoadingModal from '@/components/admin-dashboard/LoadingModal.vue';
import ConfirmationModal from '@/components/admin-dashboard/ConfirmationModal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'EventsView',
  setup(__props) {

const router = useRouter();

const events = ref<[any]>();

const showModal = ref(false);

const isLoading = ref(false);

const showConfirmation = ref(false);

const eventForDeletion = ref(null);

onMounted(async () => {
  if (!localStorage.getItem('loggedIn')) {
    router.push({ name: 'admin-login' });
    return;
  }
  try {
    events.value = await EventService.getAll();
  } catch (error) {
    console.error(error);
  }
});

function deleteEvent(event: any) {
  if (isLoading.value) return;
  eventForDeletion.value = event;
  showConfirmation.value = true;
}

async function confirmDeletion() {
  showConfirmation.value = false;
  isLoading.value = true;
  console.log(eventForDeletion.value);
  await EventService.delete(eventForDeletion.value);
  events.value = await EventService.getAll();
  isLoading.value = false;
  alert('Event and its associated images deleted successfully.');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({name: 'admin-dashboard'}))),
            src: _imports_0,
            alt: "TALAB - Ultimate Student App in London Logo",
            class: "w-32 mx-auto cursor-pointer"
          }),
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (showModal.value = true)),
            className: "px-3 py-3 text-indigo-600 bg-indigo-50 rounded-lg duration-150 hover:bg-indigo-100 active:bg-indigo-200 flex items-center cursor-pointer"
          }, _cache[4] || (_cache[4] = [
            _createElementVNode("p", { className: "mr-1" }, "Create Event", -1),
            _createElementVNode("svg", {
              class: "w-6 h-6",
              "aria-hidden": "true",
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("path", {
                stroke: "currentColor",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M5 12h14m-7 7V5"
              })
            ], -1)
          ]))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(events.value?.length ?? "Loading..."), 1),
          _cache[5] || (_cache[5] = _createElementVNode("p", { class: "font-normal text-gray-700 dark:text-gray-400" }, "events", -1))
        ]),
        _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "text-center text-3xl font-medium my-5" }, "Current events", -1)),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(events.value, (event) => {
            return (_openBlock(), _createElementBlock("div", {
              key: event.id,
              class: "w-4/12 border-2 rounded-lg overflow-hidden relative"
            }, [
              _createElementVNode("button", {
                type: "button",
                class: "text-white bg-red-600 hover:bg-red-800 focus:ring-1 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm p-2 text-center inline-flex items-center me-2 absolute right-2 top-2",
                onClick: ($event: any) => (deleteEvent(event))
              }, _cache[6] || (_cache[6] = [
                _createElementVNode("svg", {
                  class: "w-[16px] h-[16px] text-gray-800 dark:text-white",
                  "aria-hidden": "true",
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "24",
                  height: "24",
                  fill: "none",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    stroke: "currentColor",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "1.3",
                    d: "M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z"
                  })
                ], -1)
              ]), 8, _hoisted_7),
              _createElementVNode("img", {
                src: event.coverImg,
                alt: "Cover Image",
                class: "object-cover h-64 w-full"
              }, null, 8, _hoisted_8),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("p", _hoisted_10, _toDisplayString(event.title), 1),
                _createElementVNode("p", _hoisted_11, _toDisplayString(event.subTitle), 1),
                _createElementVNode("p", _hoisted_12, _toDisplayString(event.description), 1)
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    (showModal.value)
      ? (_openBlock(), _createBlock(EventModal, {
          key: 0,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (showModal.value = false))
        }))
      : _createCommentVNode("", true),
    (isLoading.value)
      ? (_openBlock(), _createBlock(LoadingModal, { key: 1 }))
      : _createCommentVNode("", true),
    (showConfirmation.value)
      ? (_openBlock(), _createBlock(ConfirmationModal, {
          key: 2,
          onCancel: _cache[3] || (_cache[3] = ($event: any) => (showConfirmation.value = false)),
          onConfirm: confirmDeletion
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})